"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var component_icon_font_1 = __importDefault(require("@rotaryintl/component-icon-font"));
var component_wbr_string_1 = __importDefault(require("@rotaryintl/component-wbr-string"));
var hook_use_bem_classes_1 = __importDefault(require("@rotaryintl/hook-use-bem-classes"));
var hook_use_on_click_outside_1 = __importDefault(require("@rotaryintl/hook-use-on-click-outside"));
var classnames_1 = __importDefault(require("classnames"));
var header_mega_nav_component_1 = __importDefault(require("../header-mega-nav/header-mega-nav.component"));
var link_dropdown_component_1 = __importDefault(require("../link-dropdown/link-dropdown.component"));
var link_component_1 = require("../link/link.component");
var link_helpers_1 = require("../link/link.helpers");
var HeaderMenu = function (props) {
  var _a, _b;
  var _c, _d, _e, _f;
  var megaNavRef = (0, react_1.useRef)(null);
  /** Account links are rendered as a MegaNav in mobile. */
  var _g = (0, react_1.useState)(false),
    isAccountMegaNavOpen = _g[0],
    setAccountMegaNavOpen = _g[1];
  var _h = (0, react_1.useState)(undefined),
    openMegaNavIndex = _h[0],
    setOpenMegaNavIndex = _h[1];
  (0, hook_use_on_click_outside_1.default)(megaNavRef, function () {
    return setOpenMegaNavIndex(undefined);
  });
  // For CSS transition of MegaNav - only animate open if currently closed.
  var _j = (0, react_1.useState)(true),
    fadeOpen = _j[0],
    setFadeOpen = _j[1];
  (0, react_1.useEffect)(function () {
    // Wait for the animation to play before updating state.
    // (avoids a re-render during the css transition)
    if (openMegaNavIndex === undefined) {
      setTimeout(function () {
        return setFadeOpen(true);
      }, 500);
    } else {
      setTimeout(function () {
        return setFadeOpen(false);
      }, 500);
    }
  }, [openMegaNavIndex]);
  var bem = (0, hook_use_bem_classes_1.default)('rwc-header-menu');
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: (0, classnames_1.default)(bem(), (_a = {}, _a[bem('', 'open')] = props.isMobileMenuOpen, _a)),
    style: {
      top: "".concat(props.mobileMenuOffset, "px")
    },
    ref: megaNavRef
  }, {
    children: [(0, jsx_runtime_1.jsx)("div", __assign({
      className: bem('anchor')
    }, {
      children: (0, jsx_runtime_1.jsxs)("div", __assign({
        className: (0, classnames_1.default)(bem('container'), 'rwc-scrollbar-grey', (_b = {}, _b[bem('container', 'open')] = openMegaNavIndex !== undefined || isAccountMegaNavOpen, _b))
      }, {
        children: [props.mainNav && props.mainNav.length > 0 && (0, jsx_runtime_1.jsx)("nav", __assign({
          className: bem('items')
        }, {
          children: (_c = props.mainNav) === null || _c === void 0 ? void 0 : _c.map(function (megaNav, megaNavIndex) {
            var _a;
            var isOpen = function () {
              return megaNavIndex === openMegaNavIndex;
            };
            return (0, jsx_runtime_1.jsxs)("div", {
              children: [(0, jsx_runtime_1.jsxs)("button", __assign({
                id: "".concat(megaNav.mainNavTitle, "-nav-button"),
                "aria-haspopup": "menu",
                "aria-expanded": isOpen(),
                "aria-controls": "".concat(megaNav.mainNavTitle, "-menu"),
                className: (0, classnames_1.default)(bem('item'), (_a = {}, _a[bem('item', 'open')] = isOpen(), _a)),
                onClick: function () {
                  setOpenMegaNavIndex(isOpen() ? undefined : megaNavIndex);
                }
              }, {
                children: [(0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
                  tag: "span"
                }, {
                  children: megaNav.mainNavTitle
                })), (0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
                  type: "fas-angle-down",
                  color: "#0067C8",
                  size: "16"
                })]
              })), (0, jsx_runtime_1.jsx)(header_mega_nav_component_1.default, __assign({}, megaNav, {
                isOpen: isOpen(),
                fadeOpen: fadeOpen,
                backButtonText: props.mobileMenuBackButtonText,
                close: function () {
                  return setOpenMegaNavIndex(undefined);
                },
                setIsMobileMenuOpen: props.setIsMobileMenuOpen
              }))]
            }, "".concat(bem('item'), "-").concat(megaNav.mainNavTitle));
          })
        })), props.utilityNavLinks && props.utilityNavLinks.length > 0 && (0, jsx_runtime_1.jsxs)("ul", __assign({
          className: bem('utility')
        }, {
          children: [(_d = props.utilityNavLinks) === null || _d === void 0 ? void 0 : _d.map(function (link) {
            return (0, jsx_runtime_1.jsx)("li", {
              children: (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
                className: bem('utility-item')
              }, link))
            }, "".concat(bem('utility-item'), "-").concat(link.linkText, "-").concat(link.linkUrl));
          }), props.signInLink && props.registerLink ? (0, jsx_runtime_1.jsxs)("li", __assign({
            className: "rwc-header-utility-nav__sign-in-links"
          }, {
            children: [(0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
              className: "rwc-header-utility-nav__item rwc-header-utility-nav__sign-in",
              preLinkText: (0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
                type: "fas-circle-user",
                size: "16"
              })
            }, props.signInLink)), (0, jsx_runtime_1.jsx)("span", {
              children: "|"
            }), (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
              className: "rwc-header-utility-nav__item rwc-header-utility-nav__register"
            }, props.registerLink))]
          })) : props.accountLabel && props.accountLinks && (0, jsx_runtime_1.jsxs)("li", {
            children: [(0, jsx_runtime_1.jsxs)("button", __assign({
              className: bem('utility-item'),
              onClick: function () {
                return setAccountMegaNavOpen(true);
              }
            }, {
              children: [(0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
                type: "fas-circle-user",
                size: "16"
              }), (0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
                tag: "span"
              }, {
                children: props.accountLabel
              })), (0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
                type: "fas-angle-right",
                size: "16"
              })]
            })), (0, jsx_runtime_1.jsx)(header_mega_nav_component_1.default, {
              mainNavTitle: props.accountLabel,
              isOpen: isAccountMegaNavOpen,
              fadeOpen: false,
              backButtonText: props.mobileMenuBackButtonText,
              close: function () {
                return setAccountMegaNavOpen(false);
              },
              setIsMobileMenuOpen: props.setIsMobileMenuOpen,
              columns: [{
                type: 'col1',
                linkGroups: [{
                  subLinks: (_e = props.accountLinks) !== null && _e !== void 0 ? _e : []
                }]
              }]
            })]
          })]
        }))]
      }))
    })), (0, jsx_runtime_1.jsx)("div", __assign({
      className: (0, classnames_1.default)(bem('sticky'), bem('sticky', 'overflow'))
    }, {
      children: (0, jsx_runtime_1.jsxs)("div", __assign({
        className: bem('sticky-container')
      }, {
        children: [(0, jsx_runtime_1.jsx)(link_dropdown_component_1.default, {
          metadataName: "language-select",
          icon: "fas-globe",
          buttonClasses: "rwc-select",
          label: props.selectedLanguage,
          links: (_f = props.languageLinks) === null || _f === void 0 ? void 0 : _f.map(link_helpers_1.createLanguageLink),
          onChange: function (link) {
            if (props.onLanguageSelect) {
              props.onLanguageSelect(link);
            }
          },
          displaySelectedCheckmark: true,
          openDirection: "up",
          elevation: "none",
          panelWidth: "full",
          border: true,
          size: "lg"
        }), (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
          className: "rwc-btn rwc-btn--primary"
        }, props.primaryLink)), (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
          className: "rwc-btn rwc-btn--secondary"
        }, props.secondaryLink))]
      }))
    }))]
  }));
};
exports.default = HeaderMenu;